/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MainFileRef { 
    _id: object;
    name: string;
    version: number;
    mimetype?: string;
    size: number;
    ext: string;
    defaultAspectRatio: string;
    defaultFileFormat: string;
    /**
     * Name of fallback image in case of banner html asset
     */
    fallbackImg?: string;
    /**
     * Metadata of asset file
     * @deprecated
     */
    metadata?: object;
    importPath?: string;
}

